import { Component } from '@angular/core';
import { ASSOCIATION_TYPE, ORDER_ITEM_NUMBER, ORDER_LINE_STATUS } from '@pos-app/data';
import { OrderGridComponent } from '../order-grid/order-grid.component';
import { Subject } from 'rxjs';
import { ICellRenderer } from 'ag-grid-community';
import { NgIf } from '@angular/common';

@Component({
    selector: 'app-action-cell',
    template: `
    <span>
      <span *ngIf="isHandPackage()" [title]="'Select item to mark as collected'" (click)="sellOrderItem()">
        <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#1f1f1f">
          <path
            d="M600-800H360v280h240v-280Zm200 0H680v280h120v-280ZM575-440H320v240h222q21 0 40.5-7t35.5-21l166-137q-8-8-18-12t-21-6q-17-3-33
            1t-30 15l-108 87H400v-80h146l44-36q5-3 7.5-8t2.5-11q0-10-7.5-17.5T575-440Zm-335 0h-80v280h80v-280Zm40 0v-360q0-33 23.5-56.5T360-880h440q33
            0 56.5 23.5T880-800v280q0 33-23.5 56.5T800-440H280ZM240-80h-80q-33 0-56.5-23.5T80-160v-280q0-33 23.5-56.5T160-520h415q85 0 164 29t127
            98l27 41-223 186q-27 23-60 34.5T542-120H309q-11 18-29 29t-40 11Z"
          />
        </svg>
      </span>
      <span class="pr-1"></span>

    </span>
  `,
    styles: [
        `
      .btn {
        line-height: 0.5;
      }

      .dispatched {
        color: green;
      }

      .stack-icon {
        position: absolute;
      }

      .stack-top {
        z-index: 9;
      }
      .stock-icon {
        top: 0px;
        position: absolute;
      }
    `,
    ],
    imports: [NgIf]
})
export class ClickAndCollectOrderGridActionRendererComponent implements ICellRenderer {
  public params: any;
  public parentComponent: OrderGridComponent;
  isNewRow = false;
  orderItemNumber = ORDER_ITEM_NUMBER;
  orderLineStatus = ORDER_LINE_STATUS;
  lineAttachments;
  unSubscribe$ = new Subject<void>();

  constructor() {}

  agInit(params: any): void {
    this.params = params;
    this.parentComponent = this.params.context.componentParent;
    if (!this.params.node.data.orderNumber) {
      this.isNewRow = true;
    }
    this.lineAttachments = params.data.attachmentIdArray;
  }

  public invokeLineAttachment(isReadOnly) {
    this.parentComponent.attachItem(this.params.node, isReadOnly);
  }

  public invokeDeleteMethod() {
    this.parentComponent.deleteItem(this.params.node);
  }

  public invokeSearchMethod() {
    this.parentComponent.searchingItem(this.params.node.data.itemNumber);
  }

  public invokeSubTotalMethod() {
    this.parentComponent.addSubTotal(this.params.node);
  }

  public invokePriceScalesMethod() {
    this.parentComponent.priceScales(this.params.node);
  }

  public isAutoAddedLine() {
    return this.params.data.parentLineNumber !== 0;
  }

  public creditInvoicedLine(): void {
    if (this.parentComponent.orderHeader.quickSaleYN !== 'Y' && !this.isCreditOrder()) {
      this.parentComponent.dispatchItem(this.params.data, ORDER_LINE_STATUS.credit);
    }
  }

  public sellOrderItem(): void {
    if (this.parentComponent.orderHeader.quickSaleYN !== 'Y' && !this.isCreditOrder()) {
      this.parentComponent.dispatchItem(this.params.data, ORDER_LINE_STATUS.selling);
    }
  }

  public convertQuoteToSalesOrder(): void {
    if (
      this.parentComponent.orderHeader.quickSaleYN !== 'Y' &&
      !this.isCreditOrder() &&
      this.parentComponent?.orderHeader?.jobRequestOrderStatus === 30
    ) {
      this.parentComponent.dispatchItem(this.params.data, ORDER_LINE_STATUS.convertQuote);
    }
  }

  public isDispatchable() {
    return (
      (this.parentComponent.cashDrawer &&
        this.parentComponent.orderHeader &&
        this.parentComponent.orderHeader.customerPaymentTerms === 'POS' &&
        this.parentComponent.orderHeader.dispatchableYN === 'Y' &&
        !(this.params.data.itemNumber.toUpperCase() === ORDER_ITEM_NUMBER.giftCard && this.params.data.readOnlyLineYN === 'Y')) ||
      // when dispatchableYN = 'Y' and payableYN = 'Y' and cash drawer not attached
      // then shopping cart  and SELL GOODS is shown
      (this.parentComponent.orderHeader &&
        this.parentComponent.orderHeader.payableYN === 'Y' &&
        this.parentComponent.orderHeader.dispatchableYN === 'Y' &&
        !this.parentComponent.cashDrawer) ||
      // when dispatchableYN = 'Y' and payableYN = 'N' then shopping cart
      // and SELL GOODS is shown and payment screen is readonly
      (this.parentComponent.orderHeader &&
        this.parentComponent.orderHeader.dispatchableYN === 'Y' &&
        this.parentComponent.orderHeader.payableYN === 'N')
    );
  }

  public isConvertToOrder() {
    return this.parentComponent.isConvertToOrder;
  }

  public isTruckIcon() {
    return (
      (this.parentComponent.orderHeader.dispatchableYN === 'Y' && this.parentComponent.orderHeader.payableYN === 'N') ||
      (this.parentComponent.orderHeader.dispatchableYN === 'Y' &&
        this.parentComponent.orderHeader.payableYN === 'Y' &&
        !this.parentComponent.cashDrawer)
    );
  }

  public isConvertToCredit() {
    return (
      this.parentComponent.orderHeader &&
      this.parentComponent.orderHeader.convertToCreditYN === 'Y' &&
      !this.parentComponent.orderHeader.orderNumber.startsWith('T') &&
      this.params.node.data.lineStatus === ORDER_LINE_STATUS.invoiced &&
      this.params.node.data.itemNumber !== ORDER_ITEM_NUMBER.subTotal &&
      // Allow for mandatory items except kit components i.e. blank association type
      (this.params.data.parentLineNumber === 0 || this.isMandatoryItem(this.params.data))
    );
  }

  public isCancelledOrInvoiced() {
    return (
      this.params.node.data.lineStatus === ORDER_LINE_STATUS.cancelled ||
      this.params.node.data.changeLineStatus === ORDER_LINE_STATUS.cancelled ||
      this.params.node.data.lineStatus === ORDER_LINE_STATUS.invoiced
    );
  }

  public isMandatoryItem(itemLine) {
    const associationType = itemLine.associationType.toUpperCase();
    return (
      associationType === ASSOCIATION_TYPE.mandatory ||
      associationType === ASSOCIATION_TYPE.paint ||
      associationType === ASSOCIATION_TYPE.fit ||
      itemLine.kitPC !== 'C'
    );
  }

  public isCreditOrder() {
    return this.parentComponent.isCreditOrder;
  }

  public isFreeGoodLine() {
    return this.params.data.freeGoodsLineYN === 'Y';
  }

  public isShowUser() {
    return this.parentComponent.isShowUser;
  }

  public isExternalUser() {
    return this.parentComponent.isExternalUser;
  }

  public isProgrammeUser() {
    return this.parentComponent.isProgrammeUser;
  }

  public isDeleteAllowed() {
    return (
      !this.isNewRow &&
      this.params.data.associationType.toUpperCase() === ASSOCIATION_TYPE.mandatory &&
      !this.parentComponent.viewSettings.enforceItemRule
    );
  }
  public isSellAllowed() {
    return (
      !this.isNewRow &&
      this.params.data.associationType.toUpperCase() === ASSOCIATION_TYPE.mandatory &&
      !this.parentComponent.viewSettings.enforceItemRule
    );
  }
  public isPriceCreditDeleteAllowed() {
    return !this.isNewRow && this.isCreditOrder() && this.params.data.parentLineNumber === 0;
  }

  public refresh(): boolean {
    return false;
  }

  public isQuoteOrder() {
    return this.parentComponent.isQuoteOrder;
  }
  public isReadOnly() {
    return this.parentComponent.isReadOnly;
  }

  public isAcknowledged() {
    return this.parentComponent?.orderHeader?.jobRequestOrderStatus === 30;
  }

  public isHandPackage(): boolean {
    return this.parentComponent.orderHeader?.jobRequestOrderStatus === 40 || this.parentComponent.orderHeader?.jobRequestOrderStatus === 50;
  }
}

